<script>
export default {
  name: 'Home',
  data: () => ({
  }),
  mounted() {
    this.checkOrigin()
  },
  methods: {
    checkOrigin() {
      // ! Cheap and nasty way to enforce everyone uses accounts domain
      if (this.$route.query.noredirect !== undefined) return
      if (window.location.origin.includes('auth')) {
        const origin = window.location.origin.split('auth')[1]
        window.location = `https://accounts${origin}/login${window.location.search}`
      } else { // ! Cheap and nasty way to enforce everyone uses /login to login
        window.location.href = `/login${window.location.search}`
      }
    }
  }
}
</script>
